import { useMutation } from '@apollo/client';
import { useCallback } from 'react';

import {
  type ReportProfileReason,
  PostProfileReportDocument,
} from 'src/generated/graphql';

export const useSubmitProfileReport = () => {
  const [postProfileReportMutation] = useMutation(PostProfileReportDocument);

  const submitProfileReport = useCallback(
    async (reason: string, comment: string, profileSlug: string) => {
      const { errors } = await postProfileReportMutation({
        variables: {
          input: {
            reason: reason as ReportProfileReason,
            comment,
            profileSlug,
          },
        },
      });

      if (errors) {
        return false;
      }
      return true;
    },
    [postProfileReportMutation],
  );

  return { submitProfileReport };
};
